var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactivateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D253C",
    d: "M23.1 76.5a3.37 3.37 0 0 1-3.36-3.37V45.66H5l20.03-21.93 20.04 21.93H30.3V65.9h15.85l10.4 10.6H23.1zM95 54.34H80.25V26.87c0-1.86-1.5-3.37-3.36-3.37H43.46l10.38 10.6h15.85v20.24H54.94l20.03 21.93L95 54.34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivateIcon);
export default __webpack_public_path__ + "static/media/reactivate-icon.082b7d88963c0c109c77e2b69e51c5e5.svg";
export { ForwardRef as ReactComponent };